import React from 'react';
import './SchemeDetails.scss';
import { DataGrid } from 'devextreme-react';
import ApiHelper from '../../helpers/ApiHelper';
import GlobalParams from '../../helpers/GlobalParams';
import { Column } from 'devextreme-react/cjs/data-grid';

const SchemeDetails = ({ total_debits, total_credits, outstanding_amount, lifeCoverFactor, benefitsData, IsCreditLifeCover }) => {

  console.log(lifeCoverFactor);
  const benefitsColumns = [
    { dataField: 'description' },
    { dataField: 'CategoryName' },
    { dataField: 'perc_of_sa', caption: '% of Sum Assured', dataType: 'boolean', visible: false },
    { dataField: 'perc_payable', visible: true },
    { dataField: 'FlatRate', visible: false },

    { dataField: 'SaPerMember', caption: 'Benefit Level', visible: true },
    { dataField: 'LifeCoverFactor', visible: false }
  ];

  function formatNumberWithCommas(value) {
    const formattedValue = Number(value).toFixed(2);
    const [integerPart, decimalPart] = formattedValue.split('.');
    const numberWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return numberWithCommas + '.' + decimalPart;
  }



  return (
    <div>
      <section className="row">
        {/* <div className="col-md-3">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ color: '#2E86C1', fontWeight: 'bold' }}>Accounts Summary</h5>
              <div className="card">
                <div className="card-body">
                  <h6 className="card-subtitle mb-2 text-muted">Total Debits</h6>
                  <p className="card-text">{formatNumberWithCommas(total_debits)}</p>
                </div>
              </div>
              <br></br>
              <div className="card">
                <div className="card-body">
                  <h6 className="card-subtitle mb-2 text-muted">Total Credits</h6>
                  <p className="card-text">{formatNumberWithCommas(total_credits)}</p>
                </div>
              </div>
              <br></br>
              <div className="card">
                <div className="card-body">
                  <h6 className="card-subtitle mb-2 text-muted">Outstanding Balance</h6>
                  <p className="card-text">{formatNumberWithCommas(outstanding_amount)}</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="col-md-12">
          <div className="card">
            {/*Display the Main Benefits*/}
            <div className="card-body">
              <p className="card-text">
                {IsCreditLifeCover === "0" && (
                  <>
                    <span style={{ color: '#2E86C1', fontWeight: 'bold' }}>Main Death Cover: </span>
                    <span style={{ color: 'red', fontWeight: 'bold' }}>{lifeCoverFactor}</span> times
                    <span style={{ color: 'red', fontWeight: 'bold' }}> Annual Salary</span>
                  </>
                )}
                {IsCreditLifeCover === "1" && (
                  <>
                    <span style={{ color: '#2E86C1', fontWeight: 'bold' }}>Main Death Cover: </span>
                    <span style={{ color: 'red', fontWeight: 'bold' }}> Outstanding Loan Balance</span>
                  </>
                )}
              </p>
            </div>
          </div>
          <br></br>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ color: '#2E86C1', fontWeight: 'bold' }}>Benefits</h5>
              <DataGrid
                dataSource={benefitsData}
                wordWrapEnabled={true}
                // columns={benefitsColumns}
                grouping={{ autoExpandAll: false }}
                summary={{
                  groupItems: [
                    {
                      column: 'Description',
                      summaryType: 'count',
                      showInGroupFooter: false
                    }
                  ]
                }}
              >
                <Column dataField="description"></Column>
                <Column dataField="CategoryName"></Column>
                <Column dataField="perc_of_sa" caption="% of Sum Assured" dataType="boolean" visible={false} ></Column>
                <Column dataField="perc_payable" visible={true}></Column>
                <Column dataField="FlatRate" visible={false}></Column>
                <Column dataField="SaPerMember" caption='Benefit Level' cellRender={(cellInfo) => {
                  const formattedAmount = parseFloat(cellInfo.data.SaPerMember).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                  return (
                    <span>{formattedAmount}</span>
                  );
                }}></Column>
                <Column dataField="LifeCoverFactor" visible={false}></Column>

              </DataGrid>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SchemeDetails;